import type { StaticImageData } from 'next/image';

import { getPublishingImage, resolveImageUrl } from '@/shared/utils/publishingAsset';

/** 이미지 로드에 실패할 때 쓰는 예시 이미지 */
export const HUB_IMAGE_FALLBACK = {
  banner:   getPublishingImage('events/hub/banner_example.jpg'),
  bannerMo: getPublishingImage('events/hub/banner_example_mo.jpg'),
  card:     getPublishingImage('events/hub/card_example.jpg'),
};

/** imageKey → banner / bannerMo / card 경로 (events/hub/banner_{key}.jpg 규칙) */
export function getHubImages(key: string) {
  return {
    banner:   getPublishingImage(`events/hub/banner_${key}.jpg`),
    bannerMo: getPublishingImage(`events/hub/banner_${key}_mo.jpg`),
    card:     getPublishingImage(`events/hub/card_${key}.jpg`),
  };
}

export function resolveHubEventImageSrc(image: string | StaticImageData): string {
  return typeof image === 'string' ? image : resolveImageUrl(image);
}
